import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { menuItems } from '../../app-menu.model';
import { MenuItemWithClaims } from '../layout.model';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private readonly breadcrumbAddedSource = new Subject<MenuItemWithClaims | undefined>();
  private readonly menuItems$: BehaviorSubject<MenuItemWithClaims[]> = new BehaviorSubject(<MenuItemWithClaims[]>[]);
  public breadcrumbAdded$ = this.breadcrumbAddedSource.asObservable();

  constructor() {
    this.refreshMenuItems();
  }

  public addBreadcrumb(item: MenuItemWithClaims): void {
    this.breadcrumbAddedSource.next(item);
  }

  public clearBreadcrumb(): void {
    this.breadcrumbAddedSource.next(undefined);
  }

  public getMenuItems(): Observable<MenuItemWithClaims[]> {
    return new Observable(fn => this.menuItems$.subscribe(fn));
  }

  private refreshMenuItems() {
    this.menuItems$.next(menuItems);
  }
}
